import React from "react";
import styled from "styled-components";
import {
  COLORS,
  Icon,
  Modal,
  Typography,
  Summary,
} from "@virkesborsen/ui-component-library";
import { formatPriceWithCurrency } from "../../../utils";
import DFRSummaryCard from "../components/DFRProductCard";

const ThankYouStep = ({ checkoutData, isLargeProperty }) => {
  const { property } = checkoutData || {};

  return (
    <>
      <Modal.Content bgColor="stone-50">
        <Container>
          <HeaderTextWrapper>
            <StyledIcon name="CheckOutlined" size="xxlarge" />
            <Typography variant="subheaderMediumMedium">
              Tack för din beställning!
            </Typography>
          </HeaderTextWrapper>
          <SectionContainer>
            <DFRSummaryCard property={property} area={property?.area} />

            <PaperContainer>
              <Typography variant="bodyMediumBaseMedium">
                {isLargeProperty ? (
                  <>
                    Eftersom den beställda fastigheten omfattar över 1 000
                    hektar kommer vi att kontakta dig inom en arbetsdag för att
                    ta fram en offert och säkerställa att allt blir rätt från
                    början. Vi hör av oss via e-post eller telefon för att gå
                    vidare.
                  </>
                ) : (
                  <>
                    Eftersom du har valt att betala direkt med Klarna aktiveras
                    tjänsten inom kort. Observera att det kan ta lite tid innan
                    all data har hämtats. informationen i din skogsövervakning
                    kommer att uppdateras kontinuerligt allt eftersom ny data
                    blir tillgänglig.
                  </>
                )}
              </Typography>
            </PaperContainer>

            {!isLargeProperty && (
              <Summary
                color="white-50"
                items={[
                  {
                    label: `Skogsövervakning - 1 år`,
                    value: formatPriceWithCurrency(checkoutData?.basePrice),
                  },
                  {
                    label: `Rabatt - ${checkoutData?.propertyDiscountPercentage}% rabatt`,
                    value: checkoutData?.propertyDiscountPrice
                      ? `- ${formatPriceWithCurrency(
                          checkoutData?.propertyDiscountPrice
                        )}`
                      : undefined,
                  },
                  {
                    label: "Rabattkod",
                    value: checkoutData?.couponDiscountPrice
                      ? `- ${formatPriceWithCurrency(
                          checkoutData?.couponDiscountPrice
                        )}`
                      : undefined,
                  },
                  {
                    label: "Moms",
                    value: formatPriceWithCurrency(checkoutData?.tax),
                  },
                  {
                    label: "Startdatum",
                    value: "Idag",
                  },
                ].filter((item) => item.value)}
                total={{
                  label: "Total",
                  value: formatPriceWithCurrency(checkoutData?.netPrice),
                  subValue: "Exklusive moms",
                }}
              />
            )}
          </SectionContainer>
        </Container>
      </Modal.Content>
    </>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 0vh;

  @media (min-width: 992px) {
    margin-bottom: 30vh;
  }
`;

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
  padding-bottom: 24px;
`;

const PaperContainer = styled.div`
  background-color: white;
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  border: 1px solid #e6e6e8;
`;

const StyledIcon = styled(Icon)``;

const HeaderTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 42px;

  @media (min-width: 992px) {
    margin-top: 30vh;
  }
`;

ThankYouStep.displayName = "ThankYou";

export default ThankYouStep;
